import { render, staticRenderFns } from "./Recipients.vue?vue&type=template&id=193b070a&scoped=true&"
import script from "./Recipients.vue?vue&type=script&lang=js&"
export * from "./Recipients.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "193b070a",
  null
  
)

export default component.exports